import React, { useEffect } from "react";
import "../styles/StaticPages.css";

export default function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="sp-root">
      <div className="sp-container">
        <div className="sp-header">
          <div className="sp-chip">Legal</div>
          <h1 className="sp-title">Privacy Policy</h1>
          <p className="sp-sub">
            Last Updated: February 24, 2026 <br />
            We respect your privacy and are committed to protecting your personal information.
          </p>
        </div>

        <div className="sp-card">

          <div className="sp-section">
            <p className="sp-section-text">
              This Privacy Policy explains how Easyworld Online (“Easyworld”, “we”, “us”, “our”)
              collects, uses, and protects your personal information when you use our website and services.
            </p>
          </div>

          <div className="sp-section">
            <h2 className="sp-section-title">1. Information We Collect</h2>
            <p className="sp-section-text">
              We may collect personal information such as your name, email address,
              phone number, delivery address, and payment-related details when you use our services.
            </p>
          </div>

          <div className="sp-section">
            <h2 className="sp-section-title">2. How We Use Information</h2>
            <p className="sp-section-text">
              Your information is used to process orders, provide services, improve
              user experience, and communicate with you regarding your orders or account.
            </p>
          </div>

          <div className="sp-section">
            <h2 className="sp-section-title">3. Sharing Information</h2>
            <p className="sp-section-text">
              We do not sell your personal data. We may share your information with
              trusted third-party service providers such as payment processors and
              delivery partners to complete your orders.
            </p>
          </div>

          <div className="sp-section">
            <h2 className="sp-section-title">4. Data Security</h2>
            <p className="sp-section-text">
              We take reasonable technical and organizational measures to protect
              your personal information from unauthorized access, misuse, or disclosure.
            </p>
          </div>

          <div className="sp-section">
            <h2 className="sp-section-title">5. Your Rights</h2>
            <p className="sp-section-text">
              You may request access, correction, or deletion of your personal data
              by contacting us through our website.
            </p>
          </div>

          <div className="sp-section">
            <h2 className="sp-section-title">6. Changes to This Policy</h2>
            <p className="sp-section-text">
              We may update this Privacy Policy from time to time. Continued use of
              our services after changes means you accept the updated policy.
            </p>
          </div>

          <div className="sp-section">
            <h2 className="sp-section-title">7. Contact</h2>
            <p className="sp-section-text">
              For any questions regarding this Privacy Policy, please contact us
              through the Contact Us page on our website.
            </p>
          </div>

        </div>
      </div>
    </div>
  );
}